<template>
  <v-card :elevation="2" class="rounded-xl">
    <v-card-title class="py-3">
      <div class="d-flex align-center">
        <v-icon class="mr-2">{{ headIcon }}</v-icon>
        <span class="font-weight-medium">{{ title }}</span>
      </div>
      <v-spacer />
      <v-progress-circular
        v-if="loading"
        indeterminate
        size="20"
        width="2"
      />
    </v-card-title>

    <v-divider />

    <v-list dense class="py-0">
      <v-list-item
        v-for="s in statuses"
        :key="s.key"
        class="py-1"
      >
        <v-list-item-avatar size="26">
          <v-avatar :color="s.color" size="26">
            <v-icon small class="white--text">{{ s.icon }}</v-icon>
          </v-avatar>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="text-subtitle-2">
            {{ s.label }}
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-chip small outlined>{{ s.count }}</v-chip>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-divider />

    <v-card-actions class="py-2">
      <v-spacer />
      <div class="text-caption grey--text">
        Atualizado {{ updatedAtText }}
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'StatusCard',
  props: {
    title: { type: String, required: true },
    headIcon: { type: String, default: 'mdi-view-dashboard' },
    statuses: {
      type: Array,
      default: () => [] // [{ key, label, icon, color, count }]
    },
    loading: { type: Boolean, default: false },
    updatedAt: { type: Date, default: () => new Date() }
  },
  computed: {
    updatedAtText () {
      const d = this.updatedAt
      return d ? new Intl.DateTimeFormat('pt-BR', {
        hour: '2-digit', minute: '2-digit'
      }).format(d) : '--:--'
    }
  }
}
</script>
